import {AudioFileEntry} from "../Bridge/Bridge_Native/MediaTypes.js";

/** Mock audio-file entries used on non-Android platforms (eg. laptop testing) where no
 *  device media-store is available. Add entries here as needed. */
export const mockAudioFiles: AudioFileEntry[] = [
	{
		filePath: "FakeTestSound.wav",
		contentUri: "https://venryx.github.io/sample-media/audio/Babbling_Creek_Brown_Noise_Minute0To1.webm",
		duration: 60_000, // 60 s, in ms
		filePathInfo: {episodeStr: null, seriesStr: null, seasonStr: null},
	},
];